import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button, Modal, Form, Input, ModalHeader, ModalBody, ModalFooter, Row, Col, Card, CardBody, Container, FormGroup, Label, FormFeedback } from 'reactstrap';
import { FaPlus, FaEdit, FaTrash, FaRegBuilding, FaCubes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { categoryActions } from '../../sagas/categorySlice';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { unitesActions } from '../../sagas/unitesSlice';

const UnitesList = () => {
    const dispatch = useDispatch();
    const unites = useSelector((state) => state.unites.list); // Adjust state path as needed
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(unitesActions.list()); // Fetch categories on component mount
    }, [dispatch]);

    useEffect(() => {

    }, [unites]);


    const handleCloseModal = () => {
        setIsModalVisible(false);
        formik.resetForm();
        dispatch(unitesActions.list()); // Fetch categories on component mount
    };

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };


    const formik = useFormik({
        initialValues: {
            code: '',
            libelle: '',
        },
        validationSchema: Yup.object({
            libelle: Yup.string().required('Libelle is required'),
        }),
        onSubmit: (values) => {
            let payload = {
                data:{
                    code: values.code,
                    libelle: values.libelle,
                },
                onSuccess: () => {
                    Swal.fire({
                                        icon: 'success',
                                        title: 'Succès',
                                        text: 'Catégorie enregistrés avec succès!',
                                        confirmButtonText: 'OK',
                                    });
                    handleCloseModal();
                }
            }
            dispatch(unitesActions.create(payload));
        },
    });


    const handleAddUnite = () => {
        formik.handleSubmit();
    }

    const handleDeleteUnite = (id) => {
        dispatch(unitesActions.delete(id));
    };

    return (
        <Container fluid>
            <Row className="mb-4" >
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCubes className="text-primary me-2" />
                                {t('unites.list')}
                            </h4>
                            <Button
                                color="primary"
                                onClick={() => toggleModal()} // Go back to the previous page
                                className="d-flex align-items-center"
                            >
                                <FaPlus className="me-2" />
                                {t('unites.new')}
                            </Button>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>

                    <Table bordered>
                        <thead>
                            <tr>
                                <th>{t('unites.code')}</th>
                                <th>{t('unites.label')}</th>
                                <th>{t('common.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {unites.length > 0 && unites.map((um) => (
                                <tr key={um.id}>
                                    <td>{um.code}</td>
                                    <td>{um.libelle}</td>
                                    <td>
                                        <Button
                                            color="danger"
                                            size="sm"
                                            onClick={() => handleDeleteUnite(um.id)}
                                        >
                                            <FaTrash /> 
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {unites.length === 0 && (
                        <div className="text-center mt-4">
                            <FaCubes size={50} className="text-muted" />
                            <h5 className="mt-2">{t('unites.noUnites')}</h5>
                        </div>
                    )}

                </CardBody>
            </Card>
            <Modal isOpen={isModalVisible} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    {t('unites.new')}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={formik.handleSubmit}>
                        
                        <FormGroup>
                            <Label for="libelle">{t('unites.label')}</Label>
                            <Input
                                type="text"
                                name="libelle"
                                id="libelle"
                                value={formik.values.libelle}
                                onChange={formik.handleChange}
                                invalid={formik.touched.libelle && Boolean(formik.errors.libelle)}
                            />
                            <FormFeedback>{formik.errors.libelle}</FormFeedback>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddUnite}>
                        {t('common.save')}
                    </Button>{' '}
                    <Button color="secondary" onClick={toggleModal}>
                        {t('common.cancel')}
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default UnitesList;